module.exports = __webpack_public_path__ + "media/bootstrap-icons/chevron-left-99fd3e7b.svg";